// sensei-app/client/ui/ClassroomInputArea.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class ClassroomInputArea extends ComponentBase {
    static styles = `
        .classroom-input-area-wrapper {
            flex-grow: 1; /* This is the key fix */
            display: flex;
            flex-direction: column;
            overflow: hidden;
            padding: 1rem;
            gap: 1rem;
        }
        .drawing-canvas-container {
            flex-grow: 1;
            position: relative;
            background-color: var(--bs-body-bg);
            border-radius: var(--bs-border-radius-lg);
            border: 2px dashed var(--bs-border-color-translucent);
        }
        .drawing-canvas {
            position: absolute;
            top: 0;
            left: 0;
            cursor: crosshair;
        }
        .text-input-container {
            flex-shrink: 0;
            display: flex;
            align-items: flex-end;
            gap: 0.5rem;
            padding: 0.5rem;
            background-color: var(--bs-tertiary-bg);
            border-radius: 1.5rem;
        }
        .text-input-container textarea {
            flex-grow: 1;
            background: transparent;
            border: none;
            resize: none;
            max-height: 150px;
            overflow-y: auto;
            outline: none;
            box-shadow: none;
            padding: 0.25rem 0.5rem;
        }
        .input-actions .btn {
            font-size: 1.2rem;
            line-height: 1;
            padding: 0.5rem;
        }
    `;

    constructor(config) {
        super(config);
        this.drawingCanvas = null;
        this.drawingContext = null;
        this.isDrawing = false;
        this.resizeObserver = null;
        this.applyStyles();
    }


    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'classroom-input-area-wrapper';
            this.container.innerHTML = `
            <div class="drawing-canvas-container">
                <canvas class="drawing-canvas"></canvas>
            </div>
            <div class="text-input-container">
                <textarea class="form-control" placeholder="${this.t('Type a message...')}" rows="1"></textarea>
                <div class="input-actions btn-group">
                    <button class="btn btn-light clear-canvas-btn" title="${this.t('Clear Drawing')}"><i class="bi bi-eraser"></i></button>
                    <button class="btn btn-primary send-btn" title="${this.t('Send')}"><i class="bi bi-send-fill"></i></button>
                </div>
            </div>
        `;
            this.setupDrawingCanvas(this.container.querySelector('.drawing-canvas'));
            this.attachEventListeners();
        }
        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }

    attachEventListeners() {
        this.container.querySelector('.send-btn').addEventListener('click', () => this.sendInput());
        this.container.querySelector('.clear-canvas-btn').addEventListener('click', () => this.clearDrawing());

        const textarea = this.container.querySelector('textarea');
        textarea.addEventListener('input', this.autoResizeTextarea);
        textarea.addEventListener('keypress', (e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                this.sendInput();
            }
        });

        const canvasContainer = this.container.querySelector('.drawing-canvas-container');
        this.resizeObserver = new ResizeObserver(() => this.handleResize());
        this.resizeObserver.observe(canvasContainer);
    }

    sendInput() {
        const textarea = this.container.querySelector('textarea');
        const text = textarea.value.trim();

        // Check if canvas is blank before converting to data URL
        const pixelBuffer = new Uint32Array(this.drawingContext.getImageData(0, 0, this.drawingCanvas.width, this.drawingCanvas.height).data.buffer);
        const isCanvasBlank = !pixelBuffer.some(color => color !== 0);

        // --- THIS IS THE FIX ---
        // Construct the payload conditionally.
        const payload = {};
        if (text) {
            payload.text = text;
        }

        if (!isCanvasBlank) {
            payload.image = this.drawingCanvas.toDataURL('image/png');
        }

        // Only emit if there is something to send.
        if (Object.keys(payload).length === 0) {
            return;
        }

        this.emit('studentInputSent', payload);
        // --- END FIX ---

        // Reset UI after sending
        textarea.value = '';
        this.autoResizeTextarea({ target: textarea });
        this.clearDrawing();
    }


    clearDrawing() {
        if (this.drawingContext) {
            this.drawingContext.clearRect(0, 0, this.drawingCanvas.width, this.drawingCanvas.height);
        }
    }

    handleResize() {
        if (!this.drawingCanvas) return;
        const container = this.drawingCanvas.parentElement;
        // --- FIX: Ensure canvas resolution matches its display size ---
        this.drawingCanvas.width = container.offsetWidth;
        this.drawingCanvas.height = container.offsetHeight;
    }

    autoResizeTextarea(event) {
        const textarea = event.target;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    }



    setupDrawingCanvas(canvas) {
        this.drawingCanvas = canvas;
        this.drawingContext = canvas.getContext('2d');
        this.drawingContext.strokeStyle = 'var(--bs-emphasis-color)';
        this.drawingContext.lineWidth = 2.5;
        this.drawingContext.lineCap = 'round';
        this.drawingContext.lineJoin = 'round';

        this.boundStartDrawing = this.startDrawing.bind(this);
        this.boundDraw = this.draw.bind(this);
        this.boundStopDrawing = this.stopDrawing.bind(this);

        canvas.addEventListener("mousedown", this.boundStartDrawing);
        canvas.addEventListener("mousemove", this.boundDraw);
        canvas.addEventListener("mouseup", this.boundStopDrawing);
        canvas.addEventListener("mouseout", this.boundStopDrawing);
        canvas.addEventListener("touchstart", this.boundStartDrawing, { passive: false });
        canvas.addEventListener("touchmove", this.boundDraw, { passive: false });
        canvas.addEventListener("touchend", this.boundStopDrawing);
    }

    getCoordinates(event) {
        const rect = this.drawingCanvas.getBoundingClientRect();
        let x, y;
        if (event.touches) {
            x = event.touches[0].clientX - rect.left;
            y = event.touches[0].clientY - rect.top;
        } else {
            x = event.clientX - rect.left;
            y = event.clientY - rect.top;
        }
        return [x, y];
    }

    startDrawing(e) { e.preventDefault(); this.isDrawing = true; const [x, y] = this.getCoordinates(e); this.drawingContext.beginPath(); this.drawingContext.moveTo(x, y); }
    draw(e) { if (!this.isDrawing) return; e.preventDefault(); const [x, y] = this.getCoordinates(e); this.drawingContext.lineTo(x, y); this.drawingContext.stroke(); }
    stopDrawing() { this.isDrawing = false; }

    destroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        super.destroy();
    }
}